import type {
  ICampaign,
  ILinks,
  Milestone,
  SocialPostType,
} from "../../../../types/models/campaign.models.types";
import type {
  SocialCreatorType,
  SocialGender,
  SocialPlatforms,
} from "../../../../types/models/social.models.types";
import type { MilestoneRewardType } from "../../../../z/brand/campaign-form.brand.z";
import { usePutHttp } from "../../http.hook";

interface IBody {
  name?: string;
  coverImage?: string;
  socialPostType?: SocialPostType | null;
  socialPlatform?: SocialPlatforms | null;
  socialCreatorType?: SocialCreatorType | null;
  genderPreference?: SocialGender | null;
  favouriteSocial?: string | null;
  minimumFollowers?: number | null;
  maximumFollowers?: number | null;
  genre?: Array<string> | null;
  locationPreference?: Array<string> | null;
  startDate?: Date | null;
  endDate?: Date | null;
  budget?: number | null;
  budgetInternal?: number | null;
  milestones?: Array<Milestone>;
  links?: Array<ILinks> | null;
  productRefund?: {
    image: string | null;
    link: string | null;
    couponCode: string | null;
    refundAmount: number | null;
  } | null;
  highestMilestoneOnlyForTopPost: string;
  assets?: Array<string>;
  sampleVideos?: Array<string> | null;
  milestoneRewardType?: MilestoneRewardType | null;
  briefVideos?: Array<string> | null;
  hashtags?: string | null;
  mentions?: string | null;
  aboutCampaign?: string | null;
  hasFixedPayout?: string | null;
  do?: string | null;
  dont?: string | null;
  aboutPayment?: string | null;
  aboutBrand?: string | null;
}

interface IResponse {
  campaign: ICampaign;
}

export function useUpdateCampaignByIdAdminHttp() {
  return usePutHttp<IBody, IResponse>({
    path: "/admin/campaigns/:id",
  });
}
